import { $axios } from 'src/boot/axios';

const defaultState = () => ({
  brandVoices: [],
  form: {
    links: [{ url: '' }],
    text: '',
    files: [],
  },
});

const actions = {
  async fetchBrandVoices({ commit }) {
    const { data } = await $axios.get('generator/brandvoices');
    commit('setBrandVoices', data.data);
  },
  async updateBrandVoice({ commit, state }, { guid, payload }) {
    const { data } = await $axios.put(`generator/brandvoices/${guid}`, payload);
    commit('setBrandVoices', state.brandVoices.map((item) => (item.guid === guid ? data.data : item)));
  },
  async removeBrandVoice(_, guid) {
    await $axios.delete(`generator/brandvoices/${guid}`);
  },
};

const mutations = {
  setBrandVoices(state, payload) {
    state.brandVoices = payload;
  },
  pushBrandVoices(state, payload) {
    state.brandVoices = [...state.brandVoices, payload];
  },
  setFormField(state, { scope, payload }) {
    state.form[scope] = payload;
  },
  clearForm(state) {
    const emptyState = defaultState();
    state.form = emptyState.form;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  state: defaultState,
};
